const messages = {
  pt: {
    'child-book-cant-renew': 'Não é possível renovar livros infantis',
    'reference-book': 'Obras de referência só podem ser emprestadas para pessoas autorizadas',
    'max-lending': 'Passou do limite de Empréstimos',
    'no-item-available': 'Sem itens disponíveis para esse livro',
    'waiting-period': 'Aguardando período de espera (3 semanas após a última vez que pegou esse livro)',
    'late-lendings': 'O membro possui empréstimos em atraso',
    'max-renovaitions': 'Passou do limite de renovações',
    'reserved-book': 'Livro está reservado para outro membro',
    'not-same-day-devolution': 'Somente empréstimos devolvidos hoje podem ter devolução revertida',
    'already-renewed': 'Livro já foi renovado hoje',
    'email-already-sent': 'Email já foi enviado hoje'
  }
}

export default messages
